import type { PhysicianSummary } from "@emr/contracts";
import "./physician-roster-badge.css";

/** An intentional usual-physician relationship, independent of the visit clinician. */
export function PhysicianRosterBadge({
  physician,
  className,
}: {
  readonly physician?: PhysicianSummary | null | undefined;
  readonly className?: string | undefined;
}) {
  if (!physician) return null;
  return (
    <span className={["physician-roster-badge", className].filter(Boolean).join(" ")}>
      Patient of {physician.displayName}
      {physician.active ? "" : " (inactive)"}
    </span>
  );
}
